/**
 * Class QuantityTotal
 * This class will control the qty increment on PDP, updating the inline Total as quantity is increased/decreased
 */
define(['jquery','priceUtils'], ($, priceUtils) => {
    class QuantityTotal {

        total = 0;

        /**
         * Constructor
         *
         * @param {Object}  config  Configuration options passed in through JSON
         * @param {Element} element The element that this class was bound to
         *
         * @returns {null}
         */
        constructor(config, element) {
            const defaultConfig = {
                controlBtn: '.qty-control',
                totalOutput: '.grouped-total'
            };
            // Merge default config options and provided config
            /** @type {Object} */
            this.config = { ...defaultConfig, ...config };
            /** @type {jQuery} */
            this.$element = $(element);

            this.$totalOutput = $(this.config.totalOutput);

            this.attachListeners();
        }

        attachListenersToQtyInputField() {
            const _self = this;
            this.$element.find("input.qty").each((i, inputElement) => {
                document.getElementsByName(inputElement.name)[0].addEventListener('change', (e) => {
                    _self.handleQtyInputChange($(e.target));
                });
            });
        }

        /**
         * Attach event listeners to elements
         *
         * @returns {null}
         */
        attachListeners() {
            this.$element.on('click', this.config.controlBtn, (e) => {
                e.preventDefault();
                const $button = $(e.target);
                this.handleClickQtyButton($button);
            });

            this.attachListenersToQtyInputField();

            // To update AfterPay installment amounts
            this.$totalOutput.on('contentUpdated', (e) => {
                const $button = $(e.target);
                this.handleClickQtyButton($button);
            });

            // When switching via colour swatches
            const itemsPriceInfoTableContainer = $('[data-js="product-items-price-info-table-container"]');
            if (itemsPriceInfoTableContainer.length) {
                itemsPriceInfoTableContainer.on('contentUpdated', (e) => {
                    this.updateTotal();
                    this.attachListenersToQtyInputField();
                });
            }

            const accessoriesPriceInfoTableContainer = $('[data-js="product-accessories-price-info-table-container"]');
            if (accessoriesPriceInfoTableContainer.length) {
                accessoriesPriceInfoTableContainer.on('contentUpdated', (e) => {
                    this.updateTotal();
                    this.attachListenersToQtyInputField();
                });
            }
        }

        /**
         * Update the qty input value depending on which button was clicked
         *
         * @param {jQuery} $button The button that was clicked
         *
         * @returns null
         */
        handleClickQtyButton($button) {
            const { action } = $button.data();
            const $qtyInput = $button.closest('.qty-with-controls').find('input.qty');
            let currentQty = parseInt($qtyInput.val(), 10);
            // if user manually clear the input, the value will be NaN, so we reset it to 0 if that's the case
            if(isNaN(currentQty)) {
                currentQty = 0;
            }

            if (currentQty <= 0 && action === 'sub') {
                $qtyInput.val(0); // Set to 0, incase someone has edited the value directly in the input
                return; // Don't try and update the qty to be less than 0
            }

            const updateBy = action === 'add' ? 1 : -1;
            $qtyInput.val(currentQty + updateBy);

            this.updateTotalInserts();

            const $validationMessageBox = $('#validation-message-box').find('.mage-error');
            if ($validationMessageBox.length && action === 'add' && $qtyInput.val() > 0) {
                $validationMessageBox.remove();
                // clear the timeout callback of hiding message box set in product-view-validation-mixin.js
                clearTimeout(window.messageTimeout);
            }

            this.updateTotal();
        }

        /**
         * Update the total based on qty input update.
         *
         * @param {jQuery} $qtyInput Input field that was updated
         *
         * @returns null
         */
        handleQtyInputChange($qtyInput) {
            let currentQty = parseInt($qtyInput.val(), 10);
            // if user manually clear the input, the value will be NaN, so we reset it to 0 if that's the case
            if(isNaN(currentQty)) {
                currentQty = 0;
            }

            if (currentQty <= 0) {
                $qtyInput.val(0); // Set to 0, incase someone has edited the value directly in the input
                this.updateTotal();
                return; // Don't try and update the qty to be less than 0
            }

            this.updateTotalInserts();

            const $validationMessageBox = $('#validation-message-box').find('.mage-error');
            if ($validationMessageBox.length && $qtyInput.val() > 0) {
                $validationMessageBox.remove();
                // clear the timeout callback of hiding message box set in product-view-validation-mixin.js
                clearTimeout(window.messageTimeout);
            }

            this.updateTotal();
        }

        /**
         * Update the total value displayed
         *
         * @returns {null}
         */
        updateTotal() {
            const total = this.calculateTotal();

            let priceText = priceUtils.formatPrice(total, {
                requiredPrecision: 2,
                integerRequired: 1,
                decimalSymbol: '.'
            }).replace('$', '');

            this.$totalOutput.text(priceText);

            if (jQuery(".afterpay-installments-amount").length){
                var ap_max      = jQuery(".afterpay-installments-amount").data('max');
                var ap_min      = jQuery(".afterpay-installments-amount").data('min');
                var ap_currency = jQuery(".afterpay-installments-amount").data('currency');
                if (total > ap_max || total < ap_min){
                    jQuery(".afterpay-installments").hide();
                }else{
                    jQuery(".afterpay-installments").show();
                    if (total.toFixed(2) > 0){
                        jQuery(".afterpay-default-message").hide();
                        jQuery(".afterpay-product-chosen-message").removeClass('hidden').show();

                        let roundedPrice = parseFloat(priceText);
                        let afterpayInstallment = priceUtils.formatPrice( (roundedPrice/4), {
                            requiredPrecision: 2,
                            integerRequired: 1,
                            decimalSymbol: '.'
                        }).replace('$', '');

                        jQuery(".afterpay-installment-amount").text(ap_currency + afterpayInstallment);
                    }else{
                        jQuery(".afterpay-default-message").removeClass('hidden').show();
                        jQuery(".afterpay-product-chosen-message").hide();
                    }
                }
            }
        }

        /**
         * Calculate a new total based on the quantities set for each product
         *
         * @returns {number}
         */
        calculateTotal() {
            const $qtyInputs = this.$element.find('input.qty');
            let total = 0;

            $qtyInputs.each((index, qtyInput) => {
                total += qtyInput.value * qtyInput.dataset.amount;
            });

            return total;
        }

        /**
         * Calculate total quantity and update Insert input
         *
         */
        updateTotalInserts() {
            const insertTextFields = this.$element.find('.insert-text-field');
            insertTextFields.each((index, insertTextField) => {
                const dataSelector = insertTextField.getAttribute('data-selector');
                const isMainInsertChecked = dataSelector ? document.querySelectorAll(
                  'input[data-selector="'+ dataSelector + '"]:not([type=hidden])')[0]?.checked : false;
                if (isMainInsertChecked) {
                    const quantityInputs = this.$element.find('input:not([type=hidden]).qty');
                    let totalQty = 0;

                    quantityInputs.each((i, quantityInput) => {
                        totalQty += parseInt(quantityInput.value, 10);
                    });

                    insertTextField.value = totalQty;
                }
            });
        }

    }

    return (config, element) => {
        const qtyTotal = new QuantityTotal(config, element);
        return qtyTotal;
    };
});
